import { type ReactNode } from 'react';
import classes from './DataGridToolbar.module.css';

export function DataGridToolbar({
  children = null,
  itemCount,
  itemName,
  itemsName,
}: {
  children?: ReactNode;
  itemCount?: number;
  itemName?: string;
  itemsName?: string;
}) {
  return (
    <div className={classes.root}>
      <SelectedCount
        itemCount={itemCount}
        itemName={itemName}
        itemsName={itemsName}
      />
      {children}
    </div>
  );
}

function SelectedCount({
  itemCount,
  itemName = 'row',
  itemsName,
}: {
  itemCount?: number;
  itemName?: string;
  itemsName?: string;
}) {
  if (!itemCount) {
    return null;
  }

  if (itemCount === 1) {
    return (
      <span className={classes.count}>
        {itemCount} selected {itemName}:
      </span>
    );
  }

  return (
    <span className={classes.count}>
      {itemCount} selected {itemsName ? itemName : `${itemName}s`}:
    </span>
  );
}
